export default "__VITE_ASSET__Di6Q455c__"